interface CardSkeletonProps {
  count?: number;
}

export function CardSkeleton({ count = 6 }: CardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
        >
          <div
            className="skeleton-shimmer animate-shimmer w-full"
            style={{ aspectRatio: "2 / 3" }}
          />
          <div className="space-y-2.5 p-3">
            <div className="skeleton-shimmer animate-shimmer h-4 w-3/4 rounded" />
            <div className="skeleton-shimmer animate-shimmer h-3 w-1/2 rounded" />
            <div className="skeleton-shimmer animate-shimmer h-3 w-2/3 rounded" />
          </div>
        </div>
      ))}
    </>
  );
}

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="col-span-full flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-3xl text-secondary-500">
        <i className={icon} />
      </span>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{title}</h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-foreground-500">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}